import MobileDeveloperPage from "./MobileDeveloperPage";

export default function ReactNativeDeveloperPage() {
  return <MobileDeveloperPage technology="reactnative" />;
}
